import 'slick-carousel';

export default function initIntroSlider() {
	jQuery('.js-intro-slider').slick({
		slidesToShow: 1,
		infinite: true,
		// dots: true,
		autoplay: true,
		autoplaySpeed: 5000,
		// prevArrow: '<button class="slick-prev"><span class="icon-arrow-l"></span></button>',
		// nextArrow: '<button class="slick-next"><span class="icon-arrow-r"></span></button>',

    dots: true,
    arrows: true,
    appendDots: $(".intro-section .slide-m-dots"),
    prevArrow: $(".intro-section .slide-m-prev"),
    nextArrow: $(".intro-section .slide-m-next")
	});
}
